import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../ui/accordion";
import { FAQS } from "../../lib/content";
import { Reveal, Eyebrow } from "../Reveal";

export const Faq = () => (
  <section id="faq" data-testid="faq" className="bg-background py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
      <div className="lg:col-span-4">
        <Eyebrow>Good to know</Eyebrow>
        <h2 className="font-display text-5xl md:text-6xl font-light tracking-tight leading-[0.95] mt-4">
          Questions,
          <br />
          <span className="text-primary italic">answered.</span>
        </h2>
        <p className="text-muted-foreground font-light leading-relaxed mt-6 max-w-sm">
          A few things groups ask before reaching out. Have another question? Just send it along with
          your request.
        </p>
      </div>

      <div className="lg:col-span-8">
        <Reveal>
          <Accordion type="single" collapsible className="w-full border-t border-border">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-border">
                <AccordionTrigger className="font-display text-xl md:text-2xl font-normal py-6 hover:no-underline hover:text-primary [&>svg]:h-5 [&>svg]:w-5 [&>svg]:text-primary">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base font-light leading-relaxed max-w-2xl pb-8">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
